import clsx from 'clsx';

import './styles.css';

export default function KitoMenuIcon({ active, onClick }) {
  return (
    <div className="kito-menu-icon__container" onClick={onClick} role="button" tabIndex={0} onKeyDown={onClick}>
      <div className={clsx('kito-menu-icon', active && 'kito-menu-icon__active')} />
    </div>
  );
}
